import SolutionCell from './SolutionCell';

export default SolutionCell;
